// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//路由
import router from './router'
//vuex
import store from './store'
//iView
import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);
//element-ui
import { Dialog,Select,Option,Input,Form,FormItem,DatePicker} from 'element-ui'
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(DatePicker);

//高德地图
import AMap from 'vue-amap';
Vue.use(AMap);
AMap.initAMapApiLoader({
  key: '9d782245378d84101888a49472ff0f19',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder']
});

//路由跳转
router.beforeEach((to, from, next) => {
	if(to.fullPath == '/newTask' || to.fullPath == '/newTask'){
		if(localStorage.aid == 2 || localStorage.aid == 4){
			next();
		}else{
			iView.Notice.warning({
                title: '权限管理',
                desc:'只有主管可以发布任务'
            });
		}
	}else if(to.fullPath == '/home/homeMoney'){
		if(localStorage.aid == 14){
			next();
		}else{
			iView.Notice.warning({
                title: '权限管理',
                desc:'只有财务可以处理提现申请'
            });
		}
	}else {
		//store.dispatch('routerPosition', from.fullPath);
		store.commit('ROUTER_QUWEY_FN', from.fullPath);
		next();
	}
})

//拖拽
import draggable from 'vuedraggable'
Vue.component('draggable', draggable);
//交互 axios

import axios from 'axios'
//配置post参数
import qs from 'qs';
Vue.config.productionTip = false
//关于axios配置
////响应时间
//axios.defaults.timeout = 5000; 
//post                       
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//axios.defaults.baseURL = 'http://123.56.86.56';   //配置接口地址
axios.interceptors.request.use(function (config) {  //配置发送请求的信息
	//请求前缀
	var prefix='/checker_web';
	config.url=prefix+config.url;
	if(config.method == 'post'){
		config.data=qs.stringify(config.data);
	}
	store.dispatch('loadingShowFn');
	return config;
}, function (error) {
	return Promise.reject(error);
});
var _this=this;
axios.interceptors.response.use(function (response) { //配置请求回来的信息
	store.dispatch('loadingHiddenFn');
	//store.dispatch('loadingHiddenFn');
	if(response.data.code){
		if(response.data.code == 400){
			router.replace({ path: '/login'}) //路由跳转
		}
	}else{
		return response.data;
	}
}, function (error) {
	return Promise.reject(error);
});
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$http = axios;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	iView,
	router,
	store,
	template: '<App/>',
	components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js